export default function _of(x){return[x];}